import React, {Component} from 'react'
import StarRatingComponent from 'react-star-rating-component'
import LaddaButton, {SLIDE_UP} from '..//LaddaButton'
import ListAscents from '../problems/ListAscents'

class Problem extends Component {
  render() {
    let {problem} = this.props
    return (
      <div className="full-width">
        <div
          className="problem"
          key={problem.id}
          style={{padding: '15px 15px'}}>
          <h2 style={{marginTop: 5, marginBottom: 0}}>{problem.name}</h2>
          <h3 style={{marginTop: 5, marginBottom: 0}}>{problem.userName}</h3>
          <StarRatingComponent
            name="boulder-rating"
            editing={false}
            starCount={5}
            emptyStarColor="#aaaaaa"
            value={problem.rating}
          />
          <div>
            {problem.grade.vgrade}/font {problem.grade.font}
          </div>
          {problem.feet && <div>{problem.feet.text}</div>}
          {problem.ascents.length && <ListAscents ascents={problem.ascents} />}
          {problem.notes && <div>{problem.notes}</div>}
        </div>
        <div>
          <LaddaButton
            key="recordascent"
            onClick={this.props.handleRecordAscentClick}
            data-color="blue"
            data-style={SLIDE_UP}
            data-spinner-color="#ddd"
            className="full-width">
            Record Ascent
          </LaddaButton>
          <LaddaButton
            key="editproblem"
            onClick={this.props.handleEditProblemClick}
            data-color="mint"
            data-style={SLIDE_UP}
            data-spinner-color="#ddd"
            className="half-width">
            Edit
          </LaddaButton>
          <LaddaButton
            key="cancelproblem"
            onClick={this.props.afterAddProblem}
            data-color="red"
            data-style={SLIDE_UP}
            data-spinner-color="#ddd"
            className="half-width">
            Back
          </LaddaButton>
        </div>
      </div>
    )
  }
}

export default Problem



// WEBPACK FOOTER //
// ./src/components/problems/Problem.jsx